import React, {useEffect, useState} from 'react'
import PhoneNumberTable from "./datas/PhoneNumberTable"
import PhoneNumberFilters from "./filters/PhoneNumberFilters"
import {message, Pagination} from "antd"
import PhoneNumberHubProvider from "./PhoneNumberHubProvider"
import parseToken from "../../../helpers/parseToken"
import {
    evictOrCancelPhoneNumber,
    getListShortPhoneByTenant,
    getListTenantNumber,
    searchTelco,
    togglePhoneNumber
} from "../../../services/api/apiCustomerHub";
import {searchTenant} from "../../../services/api/apiUser";
import {v1 as uuidv4} from 'uuid'
import {PageOptions} from "../../../helpers/constants"
import checkRole from "../../../helpers/checkRole";
import MoveNumberModal from "./actions/MoveNumberModal";
import FilterInput from "../../customers/components/filters/FilterInput";
import UseDebounce from "../../shared/UseDebounce";

function PhoneNumberHubPage() {
    const decodeToken = parseToken()
    const isMove = checkRole('menu.manage.phoneNumber.move')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listCustomers, setListCustomers] = useState([])
    const [filters, setFilters] = useState({})
    const [tenants, setTenants] = useState([])
    const [listTelco, setListTelco] = useState([])
    const [shortPhone, setShortPhone] = useState([])
    const [arrSelected, setArrSelected] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const info = parseToken()

    const [limit, setLimit] = useState(100)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)

    const [showFilter, setShowFilter] = useState(false)
    const [quickSearch, setQuickSearch] = useState('')

    const _handleChangeQuickSearch = (e) => {
        setQuickSearch(e.target.value)
    }

    const debouncedQuickSearch = UseDebounce(quickSearch, 1000)

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a href={() => false}>Previous</a>
        }
        if (type === 'next') {
            return <a href={() => false}>Next</a>
        }
        return originalElement
    }

    const _handleClearChecked = () => {
        setArrSelected([])
        setSelectedRowKeys([])
    }

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _onClearFilters = () => {
        setFilters({})
    }

    const _onChangeFilters = async (name, value) => {
        if (name === 'tenantId') {
            await _fetchListShortPhone(value)
        }
        setFilters({
            ...filters,
            [name]: value,
            page: 1
        })
    }

    const _onChangeLimit = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _fetchListTenantNumber = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                ...filters,
                phoneNumber: quickSearch || filters.phoneNumber,
                limit,
                page
            }

            const response = await getListTenantNumber(decodeToken.sub, payload)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListCustomers(data && data?.length > 0 ? data.map(item => ({...item, key: uuidv4()})) : [])
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await searchTenant(payload, info.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.id,
                }
            })

            setTenants([..._tenants])
            if (_tenants.length === 1) {
                setFilters({
                    ...filters,
                    tenantId: _tenants[0].value + ''
                })
                _fetchListShortPhone(_tenants[0].value)
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchTelco = async () => {
        try {
            const response = await searchTelco(info.sub)

            const {success, data} = response

            if (parseInt(success) !== 1) {
                return
            }
            const _telcos = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.code,
                }
            })

            setListTelco([..._telcos])
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListShortPhone = async (tenantId) => {
        try {
            const payload = {
                tenantId: parseInt(tenantId)
            }
            const response = await getListShortPhoneByTenant(info.sub, payload)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _shortPhone = data.map(item => {
                return {
                    label: item.shortPhone,
                    name: item.shortPhone,
                    value: item.shortPhone,
                }
            })

            setShortPhone([..._shortPhone])
        } catch (e) {
            message.error(e.message)
        }
    }

    const cancelPhoneNumber = async (type) => {
        try {
            const payload = {
                lstEvictOrCancelPhone: arrSelected && arrSelected?.length > 0 && arrSelected.map(item => {
                    return {
                        phoneNumber: item.phoneNumber,
                        tenantId: item.tenantId,
                        tenantName: item.teantName,
                        shortPhone: item.shortPhone
                    }
                })
            }

            const responses = await evictOrCancelPhoneNumber(info.sub, payload, type)

            const {success, message: error} = responses

            if (success !== '1') {
                return message.error(error)
            }

            _handleClearChecked()
            _fetchListTenantNumber()

            if (type === 9) {
                message.success('Hủy số thành công!')
            } else if (type === 8) {
                message.success('Thu hồi thành công!')
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const toggleBlockPhoneNumber = async (type) => {
        try {
            const payload = {
                lstEvictOrCancelPhone: arrSelected && arrSelected?.length > 0 && arrSelected.map(item => {
                    return {
                        phoneNumber: item.phoneNumber,
                        tenantId: item.tenantId,
                        tenantName: item.teantName
                    }
                })
            }

            const responses = await togglePhoneNumber(info.sub, payload, type)

            const {success, message: error} = responses

            if (success !== '1') {
                return message.error(error)
            }

            _handleClearChecked()
            _fetchListTenantNumber()

            if (type === 3) {
                message.success('Chặn số thành công!')
            } else if (type === 1) {
                message.success('Hủy chặn thành công!')
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListTenant()
        _fetchTelco()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListTenantNumber()
        // eslint-disable-next-line
    }, [filters, limit, page, debouncedQuickSearch])

    return (
        <PhoneNumberHubProvider getCustomers={_fetchListTenantNumber}>
            <div className="CustomersPage PageDefault ">
                <div className='PageHeading'>
                    <h1 className="PageTitle"></h1>
                    <div className="PageFilterTop">
                        <FilterInput
                            label=""
                            name="phoneNumber"
                            placeholder="Tìm kiếm số điện thoại"
                            value={quickSearch}
                            onChangeInput={_handleChangeQuickSearch}
                        />
                        <div className="FiltersOpen" onClick={_onToggleFilter}>
                            <span className="material-icons Filter">filter_list</span>
                            <label>Bộ lọc</label>
                        </div>
                        {
                            arrSelected.length > 0 &&
                            <button
                                className="ButtonCustom mr-3 mb-sm-0 mb-1"
                                onClick={() => cancelPhoneNumber(9)}
                            >
                                Hủy số
                            </button>
                        }
                        {
                            arrSelected.length > 0 &&
                            <button
                                className="ButtonCustom mr-3 mb-sm-0 mb-1"
                                onClick={() => cancelPhoneNumber(8)}
                            >
                                Thu hồi
                            </button>
                        }
                        {
                            arrSelected.length > 0 &&
                            <button
                                className="ButtonCustom mr-3 mb-sm-0 mb-1"
                                onClick={() => toggleBlockPhoneNumber(3)}
                            >
                                Chặn số
                            </button>
                        }
                        {
                            arrSelected.length > 0 &&
                            <button
                                className="ButtonCustom mr-3 mb-sm-0 mb-1"
                                onClick={() => toggleBlockPhoneNumber(1)}
                            >
                                Bỏ chặn
                            </button>
                        }

                        {arrSelected.length > 0 && isMove &&
                            <MoveNumberModal
                                arrSelected={arrSelected}
                                onClearChecked={_handleClearChecked}
                                onListTenantNumber={_fetchListTenantNumber}
                            />
                        }
                    </div>

                </div>

                {showFilter && (
                    <PhoneNumberFilters
                        filters={filters}
                        tenants={tenants}
                        listTelco={listTelco}
                        setFilters={setFilters}
                        shortPhone={shortPhone}
                        onChangeFilters={_onChangeFilters}
                    />
                )}

                <div className="ContentPage">
                    <PhoneNumberTable
                        loading={loading}
                        error={error}
                        setArrSelected={setArrSelected}
                        selectedRowKeys={selectedRowKeys}
                        setSelectedRowKeys={setSelectedRowKeys}
                        listCustomers={listCustomers}
                    />

                    <div className="FooterTable">
                        <div className="Total">Total {total} items</div>
                        <Pagination
                            className="PaginationCustom"
                            showSizeChanger={true}
                            total={total}
                            current={page}
                            pageSize={limit}
                            itemRender={itemRender}
                            onChange={_onChangeLimit}
                            pageSizeOptions={PageOptions}
                        />
                    </div>
                </div>
            </div>
        </PhoneNumberHubProvider>
    )
}

export default PhoneNumberHubPage
